// removed by extract-text-webpack-plugin
module.exports = {"wasabi-form":"wasabi-form","form-body":"form-body","form-submit":"form-submit"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Form/Form.scss
// module id = 239
// module chunks = 0